import { memo, useContext, useEffect } from "react";
import { Stack, ToastContainer } from "react-bootstrap";
import styled from "styled-components";

import StatusContext from "common/store/StatusContext";

import MyAlert from "../atoms/MyAlert";

import ILSidebar from "../organisms/ILSidebar";
import Topbar from "../organisms/Topbar";
import Footer from "../organisms/Footer";
import MyToast from "../atoms/MyToast";

type Props = {
  children: React.ReactNode;
};

export const DashboardTemplate = memo((props: Props) => {
  const {
    errorMessage,
    setErrorMessage,
    toastTitle,
    toastMessage,
    toastVariant,
    setToastMessage,
    sideBarOpen,
    setSideBarOpen,
  } = useContext(StatusContext);

  const menuClicked = () => {
    if (window.screen.width <= 768) setSideBarOpen(false);
  };

  useEffect(() => {
    setErrorMessage("");
  }, [setErrorMessage]);

  return (
    <>
      <SRootDiv>
        <STopRow>
          <Topbar onHumbergerClick={() => setSideBarOpen(!sideBarOpen)} />
        </STopRow>
        <ContentRow>
          <SidebarCol className={`${sideBarOpen ? "open" : "close"}`}>
            <ILSidebar className="px-2" menuClicked={menuClicked} />
          </SidebarCol>
          <MainContent className={`${!sideBarOpen ? "full" : ""}`}>{props.children}</MainContent>
        </ContentRow>
      </SRootDiv>
      <div className="fixed-bottom" style={{ zIndex: 1, pointerEvents: "none" }}>
        <Footer />
      </div>
      <ToastContainer className="p-3 fixed-top ms-auto" position="top-end" style={{ zIndex: 99 }}>
        {toastMessage && (
          <MyToast
            variant={toastVariant}
            title={toastTitle}
            message={toastMessage}
            duration={3000}
            onClose={async () => setToastMessage("")}
          ></MyToast>
        )}
      </ToastContainer>
      <SMessageStack className="fixed-top">
        {errorMessage && (
          <MyAlert variant="danger" closeRequested={() => setErrorMessage("")}>
            {errorMessage}
          </MyAlert>
        )}
      </SMessageStack>
    </>
  );
});

const SRootDiv = styled.div`
  width: 100%;
`;

const STopRow = styled.div`
  z-index: 3;
  position: "sticky";
  top: 0;
`;

const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  transition: all 0.5s ease;
  @media screen and (max-width: 768px) {
    width: 100%;
    flex-direction: column;
  }
`;

const SidebarCol = styled.div`
  width: 250px;
  justify-self: flex-start;
  margin-left: 1px;
  height: calc(100vh - 60px); /* Topbarの高さを引く */
  overflow-y: auto;
  overflow-x: hidden;
  @media screen and (min-width: 768px) {
    transition: all 0.5s ease-out;
    &.close {
      transform: translate(-250px, 0);
      width: 0;
      opacity: 0;
    }
  }
  @media screen and (max-width: 768px) {
    transition: all 1s ease-in-out;
    width: 100%;
    &.close {
      height: 0;
      opacity: 0;
    }
  }
`;

const MainContent = styled.div`
  z-index: 0;
  flex-grow: 1;
  margin-left: 5px;
  margin-right: 5px;
  width: calc(100% - 250px);
  height: calc(100vh - 60px); /* Topbarの高さを引く */
  overflow-y: auto;
  overflow-x: hidden;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  &.full {
    width: 100%;
  }
`;

const SMessageStack = styled(Stack)`
  margin-top: 0px;
`;
